<template>
  <div class="container">
    <!-- 卡片式表单区域 -->
    <el-card class="form-card">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-select
              size="mini"
              v-model="valueGame"
              placeholder="请选择游戏"
              clearable
              allow-create
              filterable
              class="custom-select"
          >
            <el-option
                v-for="item in gameOptions"
                :key="item.value"
                :label="item"
                :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="小时">
          <el-input-number
              size="mini"
              v-model="delay"
              placeholder="小时"
              :min="0"
              class="custom-input"
          ></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-date-picker
              v-model="valueDate"
              size="mini"
              type="date"
              placeholder="请选择日期"
              style="width: 140px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="custom-datepicker"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="消耗范围">
          <el-input-number
              v-model="minStatCost"
              placeholder="最小值"
              size="mini"
              :min="0"
              class="custom-input"
          ></el-input-number>
          -
          <el-input-number
              v-model="maxStatCost"
              placeholder="最大值"
              size="mini"
              :min="0"
              class="custom-input"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="倍率范围">
          <el-input-number
              v-model="minNowBl"
              placeholder="最小值"
              size="mini"
              :min="0"
              class="custom-input"
          ></el-input-number>
          -
          <el-input-number
              v-model="maxNowBl"
              placeholder="最大值"
              size="mini"
              :min="0"
              class="custom-input"
          ></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search(false)" size="mini" class="custom-button">搜索</el-button>
<!--          <el-button type="success" @click="fetchPreviousHourData(true)" size="mini" class="custom-button">-->
<!--            查询前一小时-->
<!--          </el-button>-->
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 卡片式表格区域 -->
    <el-card class="table-card">

      <el-table
          :data="filteredTableData"
          size="mini" style="width: 100%"
          border
          height="72vh"
          stripe
          class="custom-table"
      >
        <!-- 新增收藏列 -->
        <el-table-column label="收藏" width="45" align="center">
          <template slot-scope="{ row }">
            <i
                :class="isFavorite(row) ? 'el-icon-star-on' : 'el-icon-star-off'"
                :style="{ color: getStarColor(row) ,  fontSize: '15px' }"
                @click="toggleFavorite(row)" style="cursor: pointer;"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="消耗时间段" width="230" align="center">
          <template slot-scope="{ row }">
            {{ formatDateRange(row.dateHour) }}
          </template>
        </el-table-column>
        <el-table-column prop="gameName" label="游戏名称" width="150" align="center"></el-table-column>
        <el-table-column prop="accountId" label="账号Id" width="150" align="center"></el-table-column>
        <el-table-column prop="promotionId" label="计划Id" width="160" align="center"></el-table-column>
        <el-table-column prop="materialId" label="创意Id" width="160" align="center"></el-table-column>
        <el-table-column prop="hourDelay" label="小时" width="50" align="center"></el-table-column>
        <el-table-column prop="statCost" sortable label="消耗" width="140" align="center"></el-table-column>
        <el-table-column prop="acquisitionCost" label="一键起量消耗" width="140" align="center"></el-table-column>

        <el-table-column prop="nowBl" label="倍率" sortable width="100" align="center"></el-table-column>
        <el-table-column prop="nowRoi" label="roi" sortable width="100" align="center"></el-table-column>

        <el-table-column prop="status" label="状态" sortable width="180" align="center">
          <template slot-scope="{row}">
            <span v-if="row.status === '投放中'" style="color: green;">●</span>
            {{ row.status }}
          </template>
        </el-table-column>

<!--        <el-table-column label="ROI变化" width="140" align="center">-->
<!--          <template slot-scope="{ row }">-->
<!--          <span :class="{-->
<!--  'change-positive': parseFloat(calculateChange(row.nowRoi, getPreviousHourData(row) ? getPreviousHourData(row).nowRoi : null)) > 0,-->
<!--  'change-negative': parseFloat(calculateChange(row.nowRoi, getPreviousHourData(row) ? getPreviousHourData(row).nowRoi : null)) < 0-->
<!--}">  {{ calculateChange(row.nowRoi, getPreviousHourData(row) ? getPreviousHourData(row).nowRoi : null) }}-->
<!--          </span></template>-->
<!--        </el-table-column>-->

<!--        <el-table-column label="倍率变化" width="100" align="center">-->
<!--          <template slot-scope="{ row }">-->
<!--           <span :class="{-->
<!--  'change-positive': parseFloat(calculateChange(row.nowBl, getPreviousHourData(row) ? getPreviousHourData(row).nowBl : null)) > 0,-->
<!--  'change-negative': parseFloat(calculateChange(row.nowBl, getPreviousHourData(row) ? getPreviousHourData(row).nowBl : null)) < 0-->
<!--}"> {{ calculateChange(row.nowBl, getPreviousHourData(row) ? getPreviousHourData(row).nowBl : null) }}-->
<!--           </span></template>-->
<!--        </el-table-column>-->
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
          class="custom-pagination"
          layout="total"
          :total="filteredTableData.length"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import {getFavorites, addFavorite, removeFavorite} from '@/utils/favoriteUtils'; // 引入通用工具

export default {
  name: "WxHourData",
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartInstance: null,
      delay: 2,
      valueGame: "",
      valueDate: "",
      tableData: [],
      previousHourData: [], //
      favorites: [],
      filteredTableData: [], // 存储筛选后的数据
      gameOptions: [],
      minStatCost: 50, // 最小消耗
      maxStatCost: 10000, // 最大消耗
      minNowBl: 1,    // 最小倍率
      maxNowBl: 1.03     // 最大倍率
    };
  },
  mounted() {
    this.findGame();
    this.loadFavorites();
    // 设置默认日期为今天
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份补零
    const day = String(today.getDate()).padStart(2, '0');       // 日期补零
    this.valueDate = `${year}-${month}-${day}`;
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  methods: {

    // 计算变化值
    calculateChange(currentValue, previousValue) {
      if (previousValue === undefined || previousValue === null) return '无数据';
      const change = currentValue - previousValue;
      return change > 0 ? `+${change.toFixed(2)}` : change.toFixed(2);
    },

    // 获取前一小时对应的数据
    getPreviousHourData(currentRow) {
      return this.previousHourData?.find(
          item =>
              item.accountId === currentRow.accountId &&
              item.promotionId === currentRow.promotionId &&
              item.materialId === currentRow.materialId &&
              item.dateHour === currentRow.dateHour
      );
    },
    async fetchPreviousHourData() {
      const currentDate = new Date(this.valueDate);
      currentDate.setHours(currentDate.getHours() - 1);
      const queryDate = currentDate.toISOString().split('T')[0];
      const queryDelay = this.delay - 1;

      try {
        const response = await this.$axios.get(
            `/tf3/data/findHourData/${queryDelay}?gameName=${this.valueDate}&uploadTime=${this.valueGame}`
        );
        this.previousHourData = response.data.data || [];
      } catch (error) {
        console.error("前一小时数据查询失败:", error);
        this.$message.error("前一小时数据查询失败！");
      }
    },
    // 格式化时间为范围格式
    formatDateRange(dateStr) {
      if (!dateStr) return '';

      const date = new Date(dateStr);
      const startHour = date.getHours();
      const endHour = (startHour + 1) % 24; // 下一个小时，超过24则取模

      const startDate = date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      const startTime = `${String(startHour).padStart(2, '0')}:00:00`;
      const endTime = `${String(endHour).padStart(2, '0')}:00:00`;

      return `${startDate} ${startTime}~${endTime}`;
    },
    // 判断是否为收藏项
    isFavorite(row) {
      return this.favorites.some(fav =>
          fav.accountId === row.accountId &&
          fav.promotionId === row.promotionId &&
          fav.materialId === row.materialId
      );
    },  // 获取星星颜色
    getStarColor(row) {
      const favorite = this.favorites.find(fav =>
          fav.accountId === row.accountId &&
          fav.promotionId === row.promotionId &&
          fav.materialId === row.materialId
      );
      return favorite ? favorite.starColor : '#C0C4CC'; // 默认灰色
    },

    // 切换收藏状态
    // 切换收藏状态并支持颜色切换
    async toggleFavorite(row) {
      const isFav = this.isFavorite(row);
      if (isFav) {
        // 如果已收藏，移除收藏
        removeFavorite(row.accountId, row.promotionId, row.materialId);
      } else {
        // 如果未收藏，弹出颜色选择器让用户选择颜色
        const selectedColor = await this.selectStarColor();
        if (selectedColor) {
          addFavorite({
            accountId: row.accountId,
            promotionId: row.promotionId,
            materialId: row.materialId,
            starColor: selectedColor
          });
        }
      }
      this.loadFavorites(); // 更新本地收藏列表
    },  // 弹出颜色选择器
    selectStarColor() {
      return new Promise((resolve) => {
        this.$prompt('请选择星星颜色', '设置收藏颜色', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'color', // 使用 HTML5 颜色选择器
          inputValue: '#FFD700' // 默认颜色
        }).then(({value}) => {
          resolve(value); // 返回用户选择的颜色
        }).catch(() => {
          resolve(null); // 用户取消选择
        });
      });
    },
    // 加载收藏数据
    loadFavorites() {
      this.favorites = getFavorites();
    },

    async fetchStatusForItems() {
      this.statusCache = {};
      const promises = this.filteredTableData.map(async (item) => {
        const key = `${item.accountId}-${item.materialId}`;

        // 如果已经缓存过状态，则直接使用缓存
        if (this.statusCache[key]) {
          item.status = this.statusCache[key].system_status_cn;
          return;
        }

        try {
          const response = await this.$axios.post('/toufangWx/data/findStatus', {
            accountId: item.accountId,
            materialId: item.materialId,
            promotionId: ''
          });

          const status = response.data.data.system_status_cn || '未知';
          this.statusCache[key] = response.data.data; // 缓存状态
          this.$set(item, 'status', status);
          // this.$set(item, 'acquisitionCost', response.data.data.acquisition_cost);
          // this.$set(item, 'cost', response.data.data.cost);
          // this.$set(item, 'mini_game_income_roi_1', response.data.data.mini_game_income_roi_1);
        } catch (error) {
          console.error(`查询状态失败: ${key}`, error);
          item.status = '查询失败';
        }
      });

      await Promise.all(promises); // 等待所有请求完成
    },
    search(isPreviousHour = false) {
      // 参数校验
      if (!this.valueDate) {
        this.$message.warning("请先选择日期！");
        return;
      }
      let queryDelay = this.delay;

      // // 如果是查询前一小时数据
      // if (isPreviousHour) {
      //   const currentDate = new Date(this.valueDate);
      //   currentDate.setHours(currentDate.getHours() - 1); // 时间减去1小时
      //   queryDelay = this.delay + 1; // 小时延迟加1
      // }
      // 调用接口获取数据
      this.$axios
          .get(`/tf3/data/findHourData/${queryDelay}?gameName=${this.valueDate}&uploadTime=${this.valueGame}`)
          .then(response => {
            const rawData = response.data.data || [];

            // 去重：根据 promotionId + materialId 去重
            const uniqueData = Array.from(
                new Map(rawData.map(item => [`${item.promotionId}-${item.materialId}`, item])).values()
            );

            // 筛选：根据消耗和倍率范围过滤
            this.filteredTableData = uniqueData.filter(item => {
              const statCostValid =
                  (this.minStatCost === null || item.statCost >= this.minStatCost) &&
                  (this.maxStatCost === null || item.statCost <= this.maxStatCost);
              const nowBlValid =
                  (this.minNowBl === null || item.nowBl >= this.minNowBl) &&
                  (this.maxNowBl === null || item.nowBl <= this.maxNowBl);
              return statCostValid && nowBlValid;
            });

            this.tableData = uniqueData; // 保存原始数据
            this.fetchStatusForItems();
          })
          .catch(error => {
            console.error("数据查询失败:", error);
            this.$message.error("数据查询失败，请稍后重试！");
          });
    },
    findGame() {
      this.$axios.get("/toufangWx/data/findName").then(successResponse => {
        this.gameOptions = successResponse.data.data;
      });
    }
  }
};
</script>
<style scoped>.container {
  padding: 20px;
  width: 88vw;
  background-color: #f5f7fa;
}

.form-card,
.table-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.demo-form-inline .el-form-item {
  margin-right: 10px;
  align-items: center;
}

.demo-form-inline .el-form-item__label {
  width: 80px;

  text-align: right;
  font-weight: bold;
  color: #606266;
}

.custom-select,
.custom-input,
.custom-datepicker {
  width: 120px;
  border-radius: 4px;
}

.custom-button {
  border-radius: 4px;
  background-color: #409eff;
  color: white;
}

/* 自定义滚动条样式 */
.custom-table ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-table .el-table__row:hover {
  background-color: #f0f9ff;
}


.change-positive {
  color: green;
}

.change-negative {
  color: red;
}
</style>